export const MESSAGES_SIMULATE = {
    REQUIRED: (field: string) => {
        return `${field}を入力してください。`;
    },
};
